<script>
import { formatApiDate, getFileName } from "@/utils/utils";
import {
  getShareposterList,
  editPoster,
  editPosterStatus,
  previewPoster,
} from "@/api/system";
import {
  POINT_STATUS,
  getValue,
  UPLOAD_IMG_TYPE,
  DIALOG_TITLE_TYPE,
  SHARING_GRAPH_TYPE_LIST,
} from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList.vue";

export default {
  computed: {
    SHARING_GRAPH_TYPE_LIST() {
      return SHARING_GRAPH_TYPE_LIST;
    },
    POINT_STATUS() {
      return POINT_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    },
  },
  components: { UploadList },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
      },
      form: {
        id: "",
        posterUrl: [], // 图片
        goodsId: null, //商品Id
        type: 0, //类型(0:海报 1:启动页广告)
        qrLeft: "", //二维码X轴起始位置
        qrTop: "", //二维码Y轴起始位置
        qrSize: "", //二维码大小
      },
      rules: {
        qrLeft: [
          {
            required: true,
            message: "二维码X轴起始位置不能为空",
            trigger: "change",
          },
        ],
        qrTop: [
          {
            required: true,
            message: "二维码Y轴起始位置不能为空",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择分享图类型",
            trigger: "change",
          },
        ],
        qrSize: [
          { required: true, message: "二维码宽高不能为空", trigger: "change" },
        ],
      },
      dialogStatus: "",
      dialogFormVisible: false,
      btnLoading: false,
      previewImg: null,
      previewImgLoading: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
      };
      getShareposterList(params)
        .then((response) => {
          if (response && response.bizcode === 100) {
            this.list = response.data.entitys;
            this.total = response.data.totalCount;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     */
    checkDialogFormVisible(status, editObj = {}) {
      this.dialogFormVisible = status;
      this.dialogStatus =
        editObj && Object.keys(editObj).length !== 0 ? "UPDATE" : "CREATE";
      if (editObj && Object.keys(editObj).length !== 0) {
        this.form.id = editObj.id;
        this.form.qrLeft = editObj.qrLeft;
        this.form.goodsId = editObj.goodsId;
        this.form.type = editObj.type;
        this.form.qrTop = editObj.qrTop;
        this.form.qrSize = editObj.qrSize;
        if (editObj.posterUrl) {
          const attDataArr = [];
          const imgs = editObj.posterUrl;
          attDataArr.push({
            url: imgs,
            dbUrl: imgs,
            name: getFileName(imgs),
          });
          this.form.posterUrl = attDataArr;
        }
      } else {
        this.form.id = "";
        this.form.qrLeft = "";
        this.form.qrTop = "";
        this.form.qrSize = "";
        this.form.goodsId = null;
        this.form.type = 0;
        this.form.posterUrl = [];
        this.$refs.form.resetFields();
      }
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "posterUrl") {
        this.form.posterUrl = value;
      }
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const form = this.form;
          const params = {
            id: form.id,
            qrLeft: form.qrLeft,
            qrTop: form.qrTop,
            qrSize: form.qrSize,
            goodsId: form.goodsId,
            type: form.type,
          };
          if (form.posterUrl && form.posterUrl.length !== 0) {
            const urlArr = form.posterUrl.map((obj) => obj["dbUrl"]);
            params.posterUrl = urlArr.join(",");
          }
          this.btnLoading = true;
          editPoster(params)
            .then((resp) => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkDialogFormVisible(false, {});
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     * 切换分享图的状态
     * @param row
     */
    checkSharingImgStatus(row) {
      const params = {
        id: row.id,
        status: row.status === 0 ? 1 : 0,
      };
      editPosterStatus(params).then((resp) => {
        if (resp && resp.bizcode === 100) {
          this.$notify({
            title: "成功",
            message: resp.data,
            type: "success",
            duration: 2000,
          });
          this.getList();
        } else {
          this.$notify({
            title: "提示",
            message: resp.data,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    /**
     * 预览
     */
    previewFun(row) {
      console.log("row", row);
      this.previewImgLoading = true;
      const id = row.id;
      previewPoster({ id })
        .then((resp) => {
          console.log("resp", resp);
          if (resp && resp.bizcode === 100) {
            this.previewImg = resp.data;
          }
        })
        .finally(() => {
          this.previewImgLoading = false;
        });
    },
  },
};
</script>

<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {})"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">分享海报图数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      highlight-current-row
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column label="类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getValue(SHARING_GRAPH_TYPE_LIST, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column
        label="商品Id"
        align="center"
        prop="goodsId"
      ></el-table-column>
      <el-table-column
        label="二维码X轴起始位置"
        align="center"
        prop="qrLeft"
      ></el-table-column>
      <el-table-column
        label="二维码Y轴起始位置"
        align="center"
        prop="qrTop"
      ></el-table-column>
      <el-table-column
        label="二维码宽高"
        align="center"
        prop="qrSize"
      ></el-table-column>
      <el-table-column prop="imgs" label="图片" width="120px" align="center">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.posterUrl"
            style="width: 100px"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center" prop="status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="primary">{{
            getValue(POINT_STATUS, scope.row.status)
          }}</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="warning">{{
            getValue(POINT_STATUS, scope.row.status)
          }}</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="330"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            title="确定修改该分享图的状态吗？"
            @confirm="checkSharingImgStatus(scope.row)"
            style="margin: 0 8px;"
          >
            <el-button slot="reference" type="success" size="mini"
              >切换状态</el-button
            >
          </el-popconfirm>
          <el-popover
            placement="left"
            width="426"
            trigger="click"
            @hide="previewImg = null"
          >
            <el-image
              style="width: 400px; height: 576px"
              :src="previewImg"
              v-loading="previewImgLoading"
              fit="cover"
            ></el-image>
            <el-button
              slot="reference"
              type="primary"
              size="mini"
              @click="previewFun(scope.row)"
              >预览</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="图片" prop="posterUrl">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.COMMON"
            @valueFunc="getImgsValueFunc"
            paramsType="posterUrl"
            :model="form.posterUrl"
            :maxCount="1"
          />
        </el-form-item>
        <!-- 类型 -->
        <el-form-item label="类型" prop="type">
          <el-select
            v-model="form.type"
            placeholder="是否弹窗"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in SHARING_GRAPH_TYPE_LIST"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="商品Id" prop="goodsId" v-if="form.type === 1">
          <el-input v-model="form.goodsId" placeholder="请输入" />
        </el-form-item>

        <el-form-item label="二维码X轴起始位置" prop="qrLeft">
          <el-input v-model="form.qrLeft" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="二维码Y轴起始位置" prop="qrTop">
          <el-input v-model="form.qrTop" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="二维码宽高" prop="qrSize">
          <el-input v-model="form.qrSize" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false)">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
